import { render, staticRenderFns } from "./CreativeVelocity.vue?vue&type=template&id=10c976fa&scoped=true"
import script from "./CreativeVelocity.vue?vue&type=script&lang=js"
export * from "./CreativeVelocity.vue?vue&type=script&lang=js"
import style0 from "./CreativeVelocity.vue?vue&type=style&index=0&id=10c976fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c976fa",
  null
  
)

export default component.exports